export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const asArray = <T = unknown>(value: unknown): T[] => {
  if (Array.isArray(value)) return value as T[];
  if (value == null) return [];
  return [value as T];
};

export const parseJsonField = <T>(raw: unknown, fallback: T): T => {
  if (raw == null) return fallback;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw) as T;
      return parsed ?? fallback;
    } catch {
      return fallback;
    }
  }
  if (Array.isArray(raw) || isRecord(raw)) {
    return raw as T;
  }
  return fallback;
};

export const parseJsonOptional = <T>(raw: unknown): T | null => {
  if (raw == null) return null;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }
  if (Array.isArray(raw) || isRecord(raw)) {
    return raw as T;
  }
  return null;
};

export const parseJsonArray = <T>(raw: unknown): T[] => parseJsonField<T[]>(raw, []);

export const optionalString = (value: unknown): string | null =>
  typeof value === 'string' ? value : null;

export const optionalNumber = (value: unknown): number | null => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export const optionalBoolean = (value: unknown): boolean | null => {
  if (typeof value === 'boolean') return value;
  if (value === 'true') return true;
  if (value === 'false') return false;
  return null;
};
